Stylus = require("./../lib/stylus/js/search.js");


var HelpieFaq = {
    init: function() {
        console.log("HelpieFaq init()");

        jQuery('.helpie-faq.accordions.open-first .accordion').each(function() {
            var FirstItemHeaderSelector = '.accordion__item:first .accordion__header';
            jQuery(this).find(FirstItemHeaderSelector).addClass('active');
            jQuery(this).find(FirstItemHeaderSelector).next('.accordion__body')
                .stop()
                .slideDown(300);
        });

        jQuery('.accordion__header').on('click', function(e) {
            e.preventDefault();
            if (jQuery(this).hasClass('active')) {
                jQuery(this).removeClass('active');
                jQuery(this).next('.accordion__body')
                    .stop()
                    .slideUp(300);
            } else {
                console.log("else");

                if (jQuery(this).closest(".helpie-faq.accordions").hasClass('toggle')) {
                    jQuery(this).closest(".helpie-faq.accordions").find('.accordion__header').removeClass('active');
                    jQuery(this).closest(".helpie-faq.accordions").find('.accordion__body').slideUp();
                }
                jQuery(this).addClass('active');
                jQuery(this).next('.accordion__body')
                    .stop()
                    .slideDown(300);
            }
        });
    }
};

jQuery(document).ready(function() {
    HelpieFaq.init();
    Stylus.init();
});